<template>
  <div ref="pushNotificationModal" class="modal modal-v modal-v--normal fade" id="pushNotificationModal" tabindex="-1" role="dialog" aria-labelledby="pushNotificationModalLabel" aria-hidden="true">
    <div class="modal-dialog " role="document">

      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <img class="profile-show__modal-image" src="../../images/modals/notifications-modal.png" alt="coins">
          <h2 class="title">
            {{ trans.get('profile:modal.push_notification.header') }}
          </h2>

          <p class="desc">
            {{ trans.get('profile:modal.push_notification.slogan') }}
          </p>

          <div v-if="error" class="alert alert-danger">
            {{ error }}
          </div>
          <div class="buttons">
            <button type="button" class="button button__text-icon button__text-icon--modal" data-dismiss="modal" @click="delayAction">
              <i class="demo-icon icon-close"></i>
            </button>

            <button type="button" class="button button--primary" @click="acceptAction">
              {{ trans.get('profile:modal.push_notification.accept') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'PushNotificationModal',
  props: {},
  data() {
    return {
      open: false,
      revealing: {
        amount: 5,
        unit: 'm'
      },
      delay: {
        amount: 5,
        unit: 'd'
      },
      error: null,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    storageHasPushKey: function () {
      return 'hasPush.' + this.user.id;
    },
    storageDateKey: function () {
      return 'nextPushNotificationModal.' + this.user.id;
    },
  },
  watch: {
    open(val) {
      if (val) {
        $(this.$refs.pushNotificationModal).modal('show');
      } else {
        $(this.$refs.pushNotificationModal).modal('hide');
        this.delayAction();
      }
    },
  },
  methods: {
    acceptAction: function () {
      let vm = this;
      vm.error = null;

      if (window.pushMessaging === undefined) {
        vm.error = vm.trans.get('profile:modal.push_notification.other_error');
        return;
      }
      window.pushMessaging
        // popup in browser - user have to accept this
        .requestPermission()
        .then(function () {
          // get the token (now try to register in google fcm)
          return pushMessaging.getToken();
        })
        .then(function (token) {
          // properly registered token i FCM
          // registering device in backend - Laravel
          let csrf = document.querySelector('meta[name="csrf-token"]').content;
          let xhr = new XMLHttpRequest();
          xhr.open('POST', '/ajax/devices', true);
          xhr.setRequestHeader('Content-Type', 'application/json');
          xhr.send(JSON.stringify({
            source: 'web',
            token: token,
            _token: csrf
          }));

          vm.open = false;
          window.localStorage.setItem(vm.storageHasPushKey, true);
        })
        .catch(function (err) {
          console.log(err.code);
          console.log(err);
          if (err.code === 'messaging/permission-blocked') {
            vm.error = vm.trans.get('profile:modal.push_notification.permission_error');
          } else {
            vm.error = vm.trans.get('profile:modal.push_notification.other_error');
          }
        });
    },
    delayAction: function () {
      this.open = false;
      let date = moment().add(this.delay.amount, this.delay.unit);
      window.localStorage.setItem(this.storageDateKey, date.toISOString());
    },
  },
  mounted() {
    let vm = this;

    /**
     * Disable popup for safari browser
     */
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      return;
    }
    this.$eventHub.$on('PushNotificationModalOpen', () => {
      vm.open = true;
    });

    $(this.$refs.pushNotificationModal).on('hidden.bs.modal', function (e) {
      vm.open = false;
    });

    if (window.localStorage.getItem(this.storageHasPushKey)) {
      // return if already set
      return;
    }

    let localNextDate = moment(window.localStorage.getItem(this.storageDateKey));
    if (!localNextDate.isValid()) {
      // modify first revealing
      localNextDate = moment(this.user.filled_at).add(this.revealing.amount, this.revealing.unit);
    }

    if (this.user.filled_at && localNextDate.isBefore() && window.globals.show_push_notification_modal) {
      // open if time is correct
      vm.open = true;
    }
  }
};
</script>

<style scoped>

</style>
